import * as React from "react";
import { HStack, Radio } from "@chakra-ui/react";
import { AutoComplete, Form, RadioGroup, TextInput } from "components";
import { SURGEON_ROLES, useCurrentCase } from "duck";
import { getValidation, useUpdateComments } from "./duck";

const Comments: React.FC = () => {
  const diagnosticTesting = useCurrentCase(
    ({ data }) => data.client.patient.diagnosticTesting
  );
  const isDoctorRequired = useCurrentCase(
    ({ data }) => data.client.patient.dropOff.evaluateTestAndTreat === true
  );

  const validation = React.useMemo(
    () => getValidation(diagnosticTesting, isDoctorRequired),
    [diagnosticTesting, isDoctorRequired]
  );

  const onChange = useUpdateComments();

  return (
    <Form {...validation}>
      <Form.Watcher
        defaultValues={validation.defaultValues}
        onChange={onChange}
      />
      <TextInput
        type="text-area"
        label="Clinically significant abnormalities and other additional notes"
        name="abnormalitiesAndNotes"
        placeholder="Other additional notes"
      />
      <HStack mt={4} justify="space-between">
        <RadioGroup name="reviewedByDvm" label="Reviewed by DVM">
          <Radio value="false">No</Radio>
          <Radio value="true">Yes</Radio>
        </RadioGroup>
        <AutoComplete.Users
          role={SURGEON_ROLES}
          label="Doctor"
          labelHidden
          name="doctor"
          placeholder="Select a Doctor"
          menuPlacement="top"
        />
      </HStack>
    </Form>
  );
};

export default Comments;
